import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { func, node, shape, string } from 'prop-types';

export const QueryParamContext = createContext({});

/*
 * This context stores query params for a session in a state
 */
export const QueryParamProviderBase = ({ children, location, history }) => {
  const [queryParams, setQueryParams] = useState({});

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    // Can use searchParams.size but it is not supported in our testing environment
    const paramsArray = Array.from(searchParams.entries());

    if (paramsArray && paramsArray.length > 0) {
      const params = {};
      paramsArray.forEach(([key, value]) => {
        params[key] = value;
      });
      setQueryParams(params);
    }
  }, [location.search]);


  const clearQueryParams = useCallback(() => {
    // Clear the query params in the URL
    history.replace({
      pathname: location.pathname,
      search: '',
    });
    // Also update the local state
    setQueryParams({});
  }, [history, location.pathname]);

  const contextValue = {
    params: queryParams,
    clearQueryParams,
  };

  return (
    <QueryParamContext.Provider value={contextValue}>
      {children}
    </QueryParamContext.Provider>
  );
};

export const useQueryParams = () => {
  const { params, clearQueryParams } = useContext(QueryParamContext);
  return { params, clearQueryParams };
};

export const QueryParamProvider = withRouter(QueryParamProviderBase);

QueryParamProviderBase.propTypes = {
  children: node.isRequired,
  location: shape({
    search: string,
    pathname: string,
  }).isRequired,
  history: shape({
    replace: func.isRequired,
  }).isRequired,
};
